import HttpData from "@/http/data/http-data";

export interface IAccessControlDeviceData {
    device_id: number;
    device_type: string;
    name: string;
    ip_address?: string;
    subnet_mask?: string;
    gateway_address?: string;
    mac_address?: string;
    version?: string;
    date?: string;
}

export default class AccessControlDeviceData extends HttpData {
    public device_id: number;
    public device_type: string;
    public name: string;
    public ip_address?: string;
    public subnet_mask?: string;
    public gateway_address?: string;
    public mac_address?: string;
    public version?: string;
    public date?: string;

    constructor(data: IAccessControlDeviceData) {
        super();

        this.device_id = data.device_id;
        this.device_type = data.device_type;
        this.name = data.name;
        this.ip_address = data.ip_address;
        this.subnet_mask = data.subnet_mask;
        this.gateway_address = data.gateway_address;
        this.mac_address = data.mac_address;
        this.version = data.version;
        this.date = data.date;
    }
}
